<template>
  <div class="Custom-field" role="group">
    <label v-if="fieldLabel" :for="fieldName" tabindex="0">
      {{fieldLabel}}
      <b-button :id="'tooltip-'+fieldName" variant="tooltip" v-if="tooltip" :aria-label="'tooltip '+fieldName"><i class="icon-help"></i></b-button>
      <b-tooltip :target="'tooltip-'+fieldName" placement="top" v-if="tooltip">
        {{tooltip}}
      </b-tooltip>
    </label>
    <!-- step question  -->
    <cleave
      :readonly="readonly"
      :options="fieldOptions"
      :class="'form-control '+customClass"
      :id="fieldName"
      :name="fieldName"
      v-model.number="data[storeType][fieldName]"
      :value="data[storeType][fieldName]"
      v-on:blur="checkField(fieldMin, fieldMax, fieldName), customBlurFunction()"
      type="text"
      tabindex="0">
    </cleave>
    <span role="alert" v-if="errors && !errorMessage" class="form-text" v-bind:class="{ 'text-error': errors }" >Please enter figure between {{fieldMin}}-{{fieldMax}}</span>
    <span role="alert" v-if="errors && errorMessage" class="form-text" v-bind:class="{ 'text-error': errors }" v-html="errorMessage"></span>
    <span v-if="errors && customInfoBoxError" v-html="customInfoBoxError"></span>
  </div>
</template>

<script>
import Cleave from "vue-cleave-component";
import { mapFields } from "vuex-map-fields";

export default {
  name: 'CustomField',
  components: { Cleave },
  computed: {
    ...mapFields(["data"]),
  },
  props: {
    fieldName: String,
    storeType: String,
    fieldLabel: String,
    tooltip: String,
    myClass: String,
    customClass: {
      type: String,
      default: '',
    },
    fieldOptions: Object,
    fieldMin: Number,
    fieldMax: Number,
    customBlurFunction: {
      type: Function,
      default: function() { return true },
    },
    errorMessage: String,
    customInfoBoxError: String,
    readonly: Boolean,
  },
  methods: {
    checkField(min, max, fieldName) {
			// console.log('check field:', min, '|', max, '|', fieldName, '|[', this.editAssumptions[fieldName], '] -', typeof(this.editAssumptions[fieldName]));
      var val = parseFloat(this.data[this.storeType][fieldName]);
      // console.log(val);
			if(isNaN(val) || val < min) {
        this.data[this.storeType][fieldName] = min;
				this.errors = true;
			}
			else if(val > max) {
        this.data[this.storeType][fieldName] = max;
				this.errors = true;
			}
			else {
				this.errors = false;
			}
		},
  },
  data() {
    return {
      errors: false,
    }
  }
}
</script>
